import { Injectable } from '@angular/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketReservationService {

  ticketReservation: Observable<TicketReservationPlugin>;
  reservationState = ReservationState.Make;
  private ticketReservationSubject: Subject<TicketReservationPlugin>;

  constructor() {
    this.ticketReservationSubject = new Subject<TicketReservationPlugin>();
    this.ticketReservation = this.ticketReservationSubject.asObservable();
  }

  updateTicketReservation(ticketReservation: TicketReservationPlugin) {
    this.ticketReservationSubject.next(ticketReservation);
  }

  toConfirmReservation() {
    this.reservationState = ReservationState.Confirm;
  }

  toReservationDetails() {
    this.reservationState = ReservationState.Make;
  }

  toSummary() {
    this.reservationState = ReservationState.Summary;
  }
}

export enum ReservationState {
  Make,
  Confirm,
  Summary
}
